import { useContext, useEffect, useState } from "react";
import { Grid2 as Grid, Typography, Stack, Button } from "@mui/material";
import { AppContext } from "../App";
import { CLINICAL_SPECIALTIES } from "../constants/values";
import { usePostHog } from "@posthog/react";

export function ProviderClinicalSpecialties() {
  const { form, updateForm } = useContext(AppContext);
  const posthog = usePostHog();
  const [selectedItems, setSelectedItems] = useState<string[]>(form.providerClinicalSpecialties);

  useEffect(() => {
    updateForm({ providerClinicalSpecialties: selectedItems });
  }, [selectedItems]);

  const handleSelection = (spec: string) => {
    if (selectedItems.includes(spec)) {
      setSelectedItems(selectedItems.filter((item) => item !== spec)); // Deselect item
      posthog?.capture("clinical_specialty_selected", { specialty: spec, action: "deselected" });
    } else if (selectedItems.length < 3) {
      setSelectedItems([...selectedItems, spec]);
      posthog?.capture("clinical_specialty_selected", { specialty: spec, action: "selected" });
    }
  };

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="h6" gutterBottom>
        Please select the primary reasons you are seeking support:
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Select all the reasons that apply (max 3).
      </Typography>
      <Grid container spacing={2} columns={{ xs: 1, sm: 2, lg: 3 }} alignItems="stretch" justifyContent="center">
        {CLINICAL_SPECIALTIES.map((spec: string) => (
          <Grid size={1} key={spec}>
            <Button
              fullWidth
              variant={selectedItems.includes(spec) ? "contained" : "outlined"}
              onClick={() => handleSelection(spec)}
              disabled={!selectedItems.includes(spec) && selectedItems.length >= 3}
              sx={{
                height: "100%",
                minHeight: "48px",
                whiteSpace: "normal",
                lineHeight: 1.2,
              }}
            >
              <Typography className="button-label" variant="body1">
                {spec}
              </Typography>
            </Button>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
